import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import * as Styled from "./custom-legend.style";
import { graphWidth, graphMargins, } from "ui/components/panels/graphs/constants";
import { useGraphDataContext } from "providers/graph-panel";
import { rightPadding as applicationSpeedBoxRightPadding } from "ui/components/panels/dashboard/boxes/application-speed/application-speed-box.style";
export var CustomLegend = function (props) {
    var label = props.label, extraContent = props.extraContent;
    var words = label.split(/\s+/).filter(Boolean);
    return (_jsxs(Styled.LegendContainer, { children: [_jsx(Styled.LegendLabel, { children: words.map(function (word, index) { return (_jsxs(Fragment, { children: [index > 0 && _jsx("br", {}), word] }, index)); }) }), extraContent ? extraContent : null] }));
};
export var useCustomLegendWrapperStyle = function (height) {
    var responsiveContainerWidth = useGraphDataContext().responsiveContainerWidth;
    var leftPadding = 12;
    return {
        width: responsiveContainerWidth - graphWidth - applicationSpeedBoxRightPadding,
        left: graphWidth - graphMargins.right + leftPadding,
        bottom: "".concat(height / 2 - 24, "px"),
        height: 24,
    };
};
